// extracted by mini-css-extract-plugin
export var sectionCardBody = "home-module--sectionCardBody--L5x-I";
export var card = "home-module--card--f-c4b";
export var cardImage = "home-module--cardImage--Y1iw6";
export var cardContentWrapper = "home-module--cardContentWrapper--w9o7p";
export var cardContent = "home-module--cardContent--Lcvvx";
export var testimonialSection = "home-module--testimonialSection--N3mUA";